var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8057 4.32H19.4401V2.7C19.4401 2.40152 19.1986 2.16 18.9001 2.16C18.6016 2.16 18.3601 2.40153 18.3601 2.7V4.32H8.64008V2.7C8.64008 2.40152 8.39855 2.16 8.10007 2.16C7.8016 2.16 7.56007 2.40153 7.56007 2.7V4.32H5.19442C3.51853 4.32 2.16016 5.67843 2.16016 7.35426V21.8055C2.16016 23.4814 3.51858 24.8397 5.19442 24.8397H21.8056C23.4815 24.8397 24.8399 23.4813 24.8399 21.8055V7.35426C24.8399 5.67837 23.4815 4.32 21.8056 4.32H21.8057ZM5.19452 5.4H21.8057C22.8847 5.4 23.7601 6.2754 23.7601 7.35434V8.64H3.24008V7.35434C3.24008 6.2754 4.11547 5.4 5.19442 5.4H5.19452ZM21.8057 23.76H5.19452C4.11558 23.76 3.24018 22.8846 3.24018 21.8057V9.71992H23.7602V21.8057C23.7602 22.8846 22.8848 23.76 21.8058 23.76H21.8057Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.86abfac107136eda1b065110ebe441a5.svg";
export { ForwardRef as ReactComponent };